

<template>
    <header class="main-header">
        <nav class="main-menu">
            <div class="main-menu__wrapper">
                <div class="main-menu__wrapper-inner">
                    <div class="main-menu__left">
                        <div class="main-menu__logo">
                            <router-link to="/"><a href="#"><img src="assets/images/header/IEHlogo.png" alt=""></a></router-link>
                        </div>
                        
                    </div>
                    <div class="main-menu__right">
                        <div class="main-menu__right-top">
                            <div class="main-menu__right-top-left">
                                <div class="main-menu__volunteers">
                                    <!-- <div class="main-menu__volunteers-icon">
                                        <img src="assets/images/icon/main-menu-heart-icon.png" alt="">
                                    </div> -->
                                    <!-- <div class="main-menu__volunteers-text-box">
                                        <p class="main-menu__volunteers-text"><a href="become-volunteer.html">Become
                                                a
                                                <span>volunteers</span></a></p>
                                    </div> -->
                                </div>
                            </div>
                            <div class="main-menu__right-top-right">
                                <div class="main-menu__right-top-address">
                                    <ul class="list-unstyled main-menu__right-top-address-list">
                                        <li>
                                            <div class="icon">
                                                <span class="icon-phone-call"></span>
                                            </div>
                                            <div class="content">
                                                <p>Teléfono</p>
                                                <h5><a href="tel:963933691">+56 9-6393-3691</a></h5>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="icon">
                                                <span class="icon-message"></span>
                                            </div>
                                            <div class="content">
                                                <p>Enviar un Correo</p>
                                                <h5><a href="mailto:iehelectricidad@gmail.com" target="_blank">iehelectricidad@gmail.com</a>
                                                </h5>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="icon">
                                                <span class="icon-location"></span>
                                            </div>
                                            <div class="content">
                                                <a href="https://goo.gl/maps/z338oRQ3dkw1DkYC7" target="_blank"><p style="color: #283734 !important;">Casablanca,</p>
                                                <h5>Chile</h5></a>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="main-menu__right-top-social">
                                    <!--a href="#"><i class="fab fa-twitter"></i></a-->
                                    <a href="https://m.facebook.com/iehelectricidad/"><i class="fab fa-facebook"></i></a>
                                    <!--a href="#"><i class="fab fa-pinterest-p"></i></a-->
                                    <a href="https://www.instagram.com/iehoficial/"><i class="fab fa-instagram"></i></a>
                                </div>
                            </div>
                        </div>

                    <!-- Navbar -->
                        <div class="main-menu__right-bottom navbar-style">
                            <div class="main-menu__main-menu-box">
                                <a href="#" class="mobile-nav__toggler"><i class="fa fa-bars"></i></a>
                                <ul class="main-menu__list">
                                    <li class="dropdown current megamenu">
                                        <router-link to="/"><a href="#">Inicio</a></router-link>
                                        
                                    </li>
                                    <li class="dropdown">
                                        <router-link to="/about"><a href="#">Quiénes Somos</a></router-link>
                                        <!-- <ul>
                                            <li><router-link to="/about"><a href="#">About</a></router-link> </li>
                                            <li><a href="volunteer.html">Volunteer</a></li>
                                            <li><a href="become-volunteer.html">Become volunteer</a></li>
                                            <li><a href="volunteer-carousel.html">Volunteer carousel</a></li>
                                            <li><a href="gallery.html">Gallery</a></li>
                                            <li><a href="gallery-carousel.html">Gallery carousel</a></li>
                                            <li><a href="faq.html">FAQs</a></li>
                                            <li><a href="404.html">404 Error</a></li>
                                        </ul> -->
                                    </li>
                                    <!-- <li class="dropdown">
                                        <router-link to="/service"><a href="#">Nuestros Servicios</a></router-link>
                                        <ul>
                                            <li><a href="donation.html">Donation</a></li>
                                            <li><a href="donations-list.html">Donation list</a></li>
                                            <li><a href="donation-carousel.html">Donation carousel</a></li>
                                            <li><a href="donation-details.html">Donation details</a></li>
                                            <li><a href="donate-now.html">Donate Now</a></li>
                                        </ul>
                                    </li> -->
                                    <li class="dropdown">
                                        <router-link to="/electric"><a href="#">IEH Electricidad</a></router-link>
                                        <!-- <ul>
                                            <li><a href="donation.html">Donation</a></li>
                                            <li><a href="donations-list.html">Donation list</a></li>
                                            <li><a href="donation-carousel.html">Donation carousel</a></li>
                                            <li><a href="donation-details.html">Donation details</a></li>
                                            <li><a href="donate-now.html">Donate Now</a></li>
                                        </ul> -->
                                    </li>
                                    <li class="dropdown">
                                        <router-link to="/iehcontrol"><a href="#">IEH Control</a></router-link>
                                        <!-- <ul>
                                            <li><a href="donation.html">Donation</a></li>
                                            <li><a href="donations-list.html">Donation list</a></li>
                                            <li><a href="donation-carousel.html">Donation carousel</a></li>
                                            <li><a href="donation-details.html">Donation details</a></li>
                                            <li><a href="donate-now.html">Donate Now</a></li>
                                        </ul> -->
                                    </li>
                                    <li class="dropdown">
                                        <router-link to="/gallery"><a href="#">Galería</a></router-link>
                                        <!-- <ul>
                                            <li><a href="events.html">Events</a></li>
                                            <li><a href="events-carousel.html">Events carousel</a></li>
                                            <li><a href="event-details.html">Event details</a></li>
                                        </ul> -->
                                    </li>
                                    <li class="dropdown">
                                        <router-link to="/contact"><a href="#">Contáctanos</a></router-link>
                                        <!-- <ul>
                                            <li><a href="events.html">Events</a></li>
                                            <li><a href="events-carousel.html">Events carousel</a></li>
                                            <li><a href="event-details.html">Event details</a></li>
                                        </ul> -->
                                    </li>
                                   <!-- aquí contacto -->
                                    <!-- <li>
                                        <router-link to="/contact"><a href="#">Contact</a></router-link>
                                    </li> -->
                                </ul>
                            </div>
                            <div class="main-menu__main-menu-content-box">
                                <div class="main-menu__search-cat-btn-box">
                                    
                                    <div class="main-menu__btn-box">
                                       
                                        <a href="http://iehcontrol.com/#/login" target="_blank" class="main-menu__btn btn-navbar" style="color:#283734;"> 
                                                Iniciar Sesión</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </header>

    <div class="stricky-header stricked-menu main-menu">
        <div class="sticky-header__content">
            <div class="main-menu__wrapper">
                    <div class="main-menu__wrapper-inner">
                        <div class="main-menu__left">
                            <div class="main-menu__logo">
                                <router-link to="/"><a href="#"><img src="assets/images/header/IEHlogo.png" alt=""></a></router-link>
                            </div>
                            
                        </div>
                        <div class="main-menu__right">
                            <div class="main-menu__right-top">
                                <div class="main-menu__right-top-left">
                                    <div class="main-menu__volunteers">
                                        <!-- <div class="main-menu__volunteers-icon">
                                            <img src="assets/images/icon/main-menu-heart-icon.png" alt="">
                                        </div> -->
                                        <!-- <div class="main-menu__volunteers-text-box">
                                            <p class="main-menu__volunteers-text"><a href="become-volunteer.html">Become
                                                    a
                                                    <span>volunteers</span></a></p>
                                        </div> -->
                                    </div>
                                </div>
                                <div class="main-menu__right-top-right">
                                    <div class="main-menu__right-top-address">
                                        <ul class="list-unstyled main-menu__right-top-address-list">
                                            <li>
                                                <div class="icon">
                                                    <span class="icon-phone-call"></span>
                                                </div>
                                                <div class="content">
                                                    <p>Teléfono</p>
                                                    <h5><a href="tel:963933691">+56 9-6393-3691</a></h5>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="icon">
                                                    <span class="icon-message"></span>
                                                </div>
                                                <div class="content">
                                                    <p>Enviar un Correo</p>
                                                    <h5><a href="mailto:iehelectricidad@gmail.com" target="_blank">iehelectricidad@gmail.com</a>
                                                    </h5>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="icon">
                                                    <span class="icon-location"></span>
                                                </div>
                                                <div class="content">
                                                    <a href="https://goo.gl/maps/z338oRQ3dkw1DkYC7" target="_blank"><p style="color: #283734 !important;">Casablanca,</p>
                                                    <h5>Chile</h5></a>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="main-menu__right-top-social">
                                        <a href="#"><i class="fab fa-twitter"></i></a>
                                        <a href="#"><i class="fab fa-facebook"></i></a>
                                        <a href="#"><i class="fab fa-pinterest-p"></i></a>
                                        <a href="#"><i class="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div class="main-menu__right-bottom navbar-style">
                                <div class="main-menu__main-menu-box">
                                    <a href="#" class="mobile-nav__toggler"><i class="fa fa-bars"></i></a>
                                    <ul class="main-menu__list">
                                        <li class="dropdown current megamenu">
                                            <router-link to="/"><a href="#">Inicio</a></router-link>
                                            <ul>
                                                <li class="current">
                                                    
                                                </li>
                                            </ul>
                                        </li>
                                        <li class="dropdown">
                                            <router-link to="/about"><a href="#" class="text-withe color-withe">Quiénes Somos</a></router-link>
                                            <!-- <ul>
                                                <li><router-link to="/about"><a>Aboutx</a></router-link></li>
                                                <li><a href="volunteer.html">Volunteer</a></li>
                                                <li><a href="become-volunteer.html">Become volunteer</a></li>
                                                <li><a href="volunteer-carousel.html">Volunteer carousel</a></li>
                                                <li><a href="gallery.html">Gallery</a></li>
                                                <li><a href="gallery-carousel.html">Gallery carousel</a></li>
                                                <li><a href="faq.html">FAQs</a></li>
                                                <li><a href="404.html">404 Error</a></li>
                                            </ul> -->
                                        </li>
                                        <!-- <li class="dropdown">
                                            <router-link to="/service"><a href="#">Nuestros Servicios</a></router-link>
                                            <ul>
                                                <li><a href="donation.html">Donation</a></li>
                                                <li><a href="donations-list.html">Donation list</a></li>
                                                <li><a href="donation-carousel.html">Donation carousel</a></li>
                                                <li><a href="donation-details.html">Donation details</a></li>
                                                <li><a href="donate-now.html">Donate Now</a></li>
                                            </ul>
                                        </li> -->

                                        <li class="dropdown">
                                        <router-link to="/electric"><a href="#">IEH Electricidad</a></router-link>
                                        <!-- <ul>
                                            <li><a href="donation.html">Donation</a></li>
                                            <li><a href="donations-list.html">Donation list</a></li>
                                            <li><a href="donation-carousel.html">Donation carousel</a></li>
                                            <li><a href="donation-details.html">Donation details</a></li>
                                            <li><a href="donate-now.html">Donate Now</a></li>
                                        </ul> -->
                                        </li>
                                        <li class="dropdown">
                                        <router-link to="/iehcontrol"><a href="#">IEH Control</a></router-link>
                                        <!-- <ul>
                                            <li><a href="donation.html">Donation</a></li>
                                            <li><a href="donations-list.html">Donation list</a></li>
                                            <li><a href="donation-carousel.html">Donation carousel</a></li>
                                            <li><a href="donation-details.html">Donation details</a></li>
                                            <li><a href="donate-now.html">Donate Now</a></li>
                                        </ul> -->
                                        </li>
                                        <li class="dropdown">
                                            <router-link to="/gallery"><a href="#">Galería</a></router-link>
                                        <!-- <ul>
                                            <li><a href="events.html">Events</a></li>
                                            <li><a href="events-carousel.html">Events carousel</a></li>
                                            <li><a href="event-details.html">Event details</a></li>
                                        </ul> -->
                                    </li>

                                    <li class="dropdown">
                                        <router-link to="/contact"><a href="#">Contáctanos</a></router-link>
                                        <!-- <ul>
                                            <li><a href="events.html">Events</a></li>
                                            <li><a href="events-carousel.html">Events carousel</a></li>
                                            <li><a href="event-details.html">Event details</a></li>
                                        </ul> -->
                                    </li>
                                       
                                    </ul>
                                </div>
                                <div class="main-menu__main-menu-content-box">
                                    <div class="main-menu__search-cat-btn-box">
                                        
                                        <div class="main-menu__btn-box ">
                                            <a href="http://iehcontrol.com/#/login" target="_blank" class="main-menu__btn btn-navbar" style="color:#283734;"> 
                                                Iniciar Sesión</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div><!-- /.sticky-header__content -->
    </div><!-- /.stricky-header -->

    <!-- Navbar Mobile -->
    <div class="mobile-nav__wrapper">
        <div class="mobile-nav__overlay mobile-nav__toggler"></div>
        <!-- /.mobile-nav__overlay -->
        <div class="mobile-nav__content navbar-style">
            <span class="mobile-nav__close mobile-nav__toggler"><i class="fa fa-times"></i></span>

            <div class="logo-box">
                <a href="index.html" aria-label="logo image"><img src="assets/images/other/ieh.png" width="143"
                        alt="" /></a>
            </div>
            <!-- /.logo-box -->
            <div class="mobile-nav__container"></div>
            <!-- /.mobile-nav__container -->

            <ul class="mobile-nav__contact list-unstyled">

                <li class="nav-mob">
                    <router-link to="/"><a href="#">Inicio</a></router-link>
                </li>

                <li class="nav-mob">
                    <router-link to="/about"><a href="#" class="text-withe color-withe">Quiénes Somos</a></router-link>
                </li>

                <li class="nav-mob">
                    <router-link to="/electric"><a href="#" class="text-withe color-withe">IEH Electricidad</a></router-link>
                </li>

                <li class="nav-mob">
                    <router-link to="/iehcontrol"><a href="#" class="text-withe color-withe">IEH Control</a></router-link>
                </li>

                <li class="nav-mob">
                    <router-link to="/gallery"><a href="#" class="text-withe color-withe">Galería</a></router-link>
                </li>

                <li class="nav-mob">
                    <router-link to="/contact"><a href="#" class="text-withe color-withe">Contáctanos</a></router-link>
                </li>

                <li class="nav-mob">
                    <a href="http://iot.iehcontrol.com/#/login" class="text-withe color-withe" target="_blank">Iniciar Sesión</a>
                </li>

                <li>
                    <i class="fa fa-envelope"></i>
                    <a href="mailto:iehelectricidad@gmail.com">iehelectricidad@gmail.com</a>
                </li>
                <li>
                    <i class="fa fa-phone-alt"></i>
                    <a href="tel:963933691">+56 9-6393-3691</a>
                </li>
            </ul><!-- /.mobile-nav__contact -->
            <div class="mobile-nav__top">
                <div class="mobile-nav__social">
                    <!--a href="https://twitter.com/iehelectricidad" class="fab fa-twitter" target="_blank"></a-->
                    <a href="https://m.facebook.com/iehelectricidad/" class="fab fa-facebook-square" target="_blank"></a>
                    <!-- <a href="#" class="fab fa-pinterest-p"></a> -->
                    <a href="https://www.instagram.com/iehoficial/" class="fab fa-instagram" target="_blank"></a>
                </div><!-- /.mobile-nav__social -->
            </div><!-- /.mobile-nav__top -->



        </div>
        <!-- /.mobile-nav__content -->
    </div> <!-- Navbar Mobile END-->
    <!-- /.mobile-nav__wrapper -->
</template>
<style>

  .main-menu__btn:hover {
    background-color: #a8cf36;
    color: white !important;
}
  .main-menu__btn:hover:before {
  background-color: #a8cf36 !important;
}

.mobile-nav__content {
    background-color: #32a1d9 !important;
}

.main-menu__right-top-address-list li .icon {
    position: relative;
    display: flex;
    align-items: center;
    background-color: #32a1d9;
    padding: .5rem;
    border-radius: 2rem;
}

.contact-one__icon span {
    color: #283734;
}

.main-menu__right-top-address-list li .icon span {
    color: #283734;
}

.thm-btn {
    background-color: var(--oxpins-primary);
    color: #283734;
}
/*
  .main-menu__btn {
   background-color:  #647cbc !important;
}

.main-menu__btn:before {
   background-color:  #647cbc !important;
}

  .navbar-style {
    background-color: #adce3e !important;
  }*/
</style>
<script>

export default {
        mounted(){
            this.thmSwiperInit();
        },
        methods:{
            thmSwiperInit() {
                if ($(".mobile-nav__toggler").length) {
                $(".mobile-nav__toggler").on("click", function (e) {
                e.preventDefault();
                $(".mobile-nav__wrapper").toggleClass("expanded");
                // $("body").toggleClass("locked");
                });
            }
            }
        }
    }


</script>